<!-- =========================================================================================
  File Name: ECommerceShop.vue
  Description: eCommerce Shop Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div v-if="inMaintenance">
      <div class="flex flex-col justify-center text-center p-8">
        <h1 class="m-4"><b>Anfora</b></h1>
        <h3 class="m-4">Tienda en mantenimento</h3>
        <h5 class="text-center">
          Lamentamos mucho no poder atenderte en este momento, si deseas ordenar uno de nuestros deliciosos productos por favor llama al
          <a href="tel:+50224990000" class="text-center">
              (502) 2499 0000
          </a>
        </h5>
      </div>
    </div>
    <div v-else id="anf-content-container" class="relative flex justify-center clearfix">
      <pending-order :isPendingActive="pendingWindowActive" @closePending="pendingWindowActive = false"/>
      <div class="flex-1 max-w-5xl mx-auto" v-show="loaded">
        <div class="z-50 sticky top-0">
          <!-- HEADER -->
          <div class="flex items-center bg-black">
            <div class="lg:hidden mt-2 h-full w-12 content-center items-center bg-primary" @click="activateSidebar">
              <span class="flex text-white my-2 mx-1 content-center items-center z-50"><vs-icon icon="menu" size="medium"/></span>
            </div>
            <div class="hidden lg:flex ml-4 mt-1 cursor-pointer" @click="goHome">
              <img src="@/assets/images/logo/LogoFull.png" height="40" alt="Anfora">
            </div>
            <div class="lg:hidden flex mt-1 ml-4 cursor-pointer" @click="goHome">
              <img src="@/assets/images/logo/Logo.png" height="50" alt="Anfora">
            </div>

            <!-- SEARCH BAR -->
            <!--            <div class="flex-1 items-center h-24 sm:mx-4 md:mx-8 lg:mx-16 xl:mx-32">-->
            <div class="flex-1 items-center h-24 mx-4">
              <div class="flex h-full justify-start relative py-4">
                <div v-if="inHomeScreen || inLocationsScreen" class="h-full ml-px flex items-center hover:bg-grey-light cursor-pointer text-white hover:text-grey-dark" @click="setCategory(null)">
                  <span class="mx-2 sm:mx-4 text-md xl:text-xl">
                    <vs-icon class="block sm:hidden" icon="store" size="small"/>
                    <b class="hidden sm:block">TIENDA</b>
                  </span>
                </div>
                <div class="h-full ml-px flex items-center hover:bg-grey-light cursor-pointer text-white hover:text-grey-dark" @click="$router.push({ name: 'locations' })">
                  <span class="mx-2 sm:mx-4 text-md xl:text-xl">
                    <vs-icon class="block sm:hidden" icon="location_on" size="small"/>
                    <b v-if="inHomeScreen" class="hidden sm:block">UBICACIONES</b>
                  </span>
                </div>
<!--
                <div class="h-full ml-px flex items-center hover:bg-grey-light cursor-pointer text-white hover:text-grey-dark">
                  <span class="mx-2 sm:mx-4 xl:mx-8 text-md xl:text-xl">
                    <vs-icon class="block sm:hidden" icon="email" size="small"/>
                    <b class="hidden sm:block">CONTÁCTANOS</b>
                  </span>
                </div>
-->
                <div class="hidden lg:flex w-full relative mt-2 mx-4">

                <!-- SEARCH INPUT -->
                <vs-input class="w-full vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg" placeholder="Buscar..." :value="currentRefinement" @input="refine($event)" @keyup.esc="refine('')" size="large"/>

                <!-- SEARCH ICON -->
                <div slot="submit-icon" class="absolute top-0 right-0 py-4 px-6" v-show="!currentRefinement">
                  <feather-icon icon="SearchIcon" svgClasses="h-6 w-6"/>
                </div>

                <!-- CLEAR INPUT ICON -->
                <div slot="reset-icon" class="absolute top-0 right-0 py-4 px-6" v-show="currentRefinement">
                  <feather-icon icon="XIcon" svgClasses="h-6 w-6 cursor-pointer" @click="refine('')"/>
                </div>
              </div>
              </div>
            </div>
            <span class="mt-4 mr-4">
              <a href="tel:+50224990000" class="flex justify-start items-center mb-2">
                <vs-icon icon="phone" size="medium" class="mr-2" color="white"/>
<!--                  <img src="@/assets/images/motorcycle.png" alt="Domicilio" class="mr-2" height="36"/>-->
                <div class="hidden lg:flex flex-col text-white">
                  <div class="text-2xl">2499 0000</div>
                </div>
              </a>
            </span>
            <vx-tooltip v-if="giftOrdersActivated" position="bottom" text="Enviar para regalo">
              <feather-icon icon="GiftIcon" class="cursor-pointer ml-4 mr-6 mt-4" @click="setGiftOrder"/>
            </vx-tooltip>
            <cart-drop-down class="mt-2"/>
            <user class="mt-2"/>
          </div>
          <div class="flex items-center justfy-end bg-primary text-white p-1">
            <vs-spacer/>
            <span v-if="selectedStore" class="cursor-pointer" @click="$router.push({ name: 'locations' })">
              <span v-if="deliveryType == 'delivery'">La tienda <b>{{ selectedStore.name }}</b> entregará tu pedido</span>
              <span v-else>Recogerás tu pedido en la tienda <b>{{ selectedStore.name }}</b></span>
            </span>
            <span v-else class="cursor-pointer" @click="$router.push({ name: 'locations' })">No has seleccionado tienda</span>
          </div>
          <div v-if="!inCheckoutScreen && !inLocationsScreen" class="flex lg:hidden relative m-2">

            <!-- SEARCH INPUT -->
            <vs-input class="w-full vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg" placeholder="Buscar..." v-model="currentRefinement" size="large"/>

            <!-- CLEAR INPUT ICON -->
            <div slot="reset-icon" class="absolute top-0 right-0 py-4 px-12" v-show="currentRefinement">
              <feather-icon icon="XIcon" svgClasses="h-6 w-6 cursor-pointer" @click="currentRefinement = ''"/>
            </div>

            <!-- SEARCH ICON -->
            <div slot="submit-icon" class="absolute top-0 right-0 py-4 px-2">
              <feather-icon icon="SearchIcon" svgClasses="h-6 w-6" @click="refine(currentRefinement)"/>
            </div>
          </div>

          <!-- CATEGORIES IN LARGE SCREENS -->
          <div v-if="!inLocationsScreen" class="hidden lg:flex justify-center items-center" style="background-color: #f0f0f0;">
            <div class="flex h-12 xl:h-16 items-center">
              <div class="h-full flex-1 ml-px"/>
              <div
                v-for="category in mainCategories"
                :key="category.id"
                class="h-full flex ml-px hover:bg-grey-light"
                v-bind:style="{'background-color': categoryColor(category)}"
                @mouseover="hoverCategory = category" @mouseleave="hoverCategory = null"
              >
                  <span
                    class="mx-4 xl:mx-10 text-md xl:text-xl my-auto cursor-pointer"
                    :class="[{'text-primary': (selectedCategory && category.id != selectedCategory.id) || !selectedCategory}, {'text-white': selectedCategory && category.id == selectedCategory.id}]"
                    @click="toCategory(category)"
                  >
                    <b>{{ category.name.toUpperCase() }}</b>
                  </span>
                <div style="width: 16rem; position: absolute; display: inline-block; top: 12rem; z-index: 1000;" v-show="showSubcategories(category)">
              <span
                v-for="subCategory in subCategories(category)"
                :key="subCategory.id"
                @click="toCategory(subCategory)"
                class="flex p-6 m-px text-primary text-lg cursor-pointer"
                id="anf-sub-c"
              >
                <b>{{ subCategory.name.toUpperCase() }}</b><br/>
              </span>
                </div>
              </div>
              <vs-spacer/>
              <!--              <div class="h-full flex-1 ml-px" style="background-color: #EEEEEE;"/>-->
            </div>
          </div>
        </div>

        <!-- BREADCRUMBS -->
        <div class="flex items-start h-6 lg:h-4 ml-4 mt-1" v-if="inProductsScreen || inItemScreen">
            <span class="flex items-center cursor-pointer" @click="goHome">
              <vs-icon icon="home" size="1.7rem" class="mr-2"/>
              <span class="lg:text-lg">Inicio</span>
            </span>
          <span class="flex items-center cursor-pointer" v-for="breadcrumb in breadcrumbs" :key="breadcrumb.title" @click="toCategory(breadcrumb.category)">
              <vs-icon icon="keyboard_arrow_right" size="small"/>
              <span class="lg:text-lg">{{ breadcrumb.title }}</span>
            </span>
        </div>

        <div id="anf-main-container">
          <!-- HOME SCREEN - HIGHLIGHTED PRODUCTS -->
          <home class="mt-2 mx-2" v-if="inHomeScreen"/>

          <!-- PRODUCTS SCREEN -->
          <div v-show="inProductsScreen">

            <!-- SEARCH RESULT -->
            <div class="flex my-4 ml-4">
              <div class="hidden lg:flex lg:mr-4 lg:vx-col items-no-padding background-absolute" style="width: 280px;">
                <vx-card>
                  <div class="p-2 filter-container">
                    <h6 class="font-bold mb-3">Categorías</h6>
                    <div @click="setCategory(null)" class="flex items-center cursor-pointer py-1">
                      <feather-icon icon="CircleIcon" :svgClasses="[{ 'text-primary fill-current': !selectedCategory}, 'h-5 w-5']"/>
                      <span class="ml-2" :class="{'text-primary': !selectedCategory}">Todos</span>
                    </div>
                    <div v-for="item in mainCategories" :key="item.id">
                      <div @click="toCategory(item)" class="flex items-center cursor-pointer py-1">
                        <feather-icon icon="CircleIcon" :svgClasses="[{ 'text-primary fill-current': selectedCategory && item.id == selectedCategory.id}, 'h-5 w-5']"/>
                        <span class="ml-2" :class="{'text-primary': selectedCategory && item.id == selectedCategory.id}">{{ item.name }}</span>
                      </div>
                      <div v-for="subCategory in subCategories(item)" :key="subCategory.id" class="flex ml-6 text-md">
                        <div @click="toCategory(subCategory)" class="flex items-center cursor-pointer py-1 text-sm">
                          <feather-icon icon="CircleIcon" :svgClasses="[{ 'text-primary fill-current': selectedCategory && subCategory.id == selectedCategory.id}, 'h-5 w-5']"/>
                          <span class="ml-2" :class="{'text-primary': selectedCategory && subCategory.id == selectedCategory.id}">{{ subCategory.name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <vs-divider/>

                  <div class="p-2 filter-container">
                    <h6 class="font-bold mb-3">Rango de precios:</h6>
                    <ul>
                      <li class="flex items-center cursor-pointer py-1 text-sm" @click="refinePriceRange(null)">
                        <feather-icon icon="CircleIcon" :svgClasses="[{ 'text-primary fill-current': !selectedPriceRange}, 'h-5 w-5']"/>
                        <span class="ml-2" :class="{'text-primary': !selectedPriceRange}">Todos</span>
                      </li>
                      <li
                        v-for="item in priceRanges"
                        :key="item.id"
                        class="flex items-center cursor-pointer py-1"
                        @click="refinePriceRange(item)">

                        <feather-icon icon="CircleIcon" :svgClasses="[{ 'text-primary fill-current': selectedPriceRange && item.id == selectedPriceRange.id}, 'h-5 w-5']"/>
                        <span class="ml-2" :class="{'text-primary': selectedPriceRange && item.id == selectedPriceRange.id}">{{ item.label }}</span>
                      </li>
                    </ul>
                  </div>

                  <vs-divider/>

                  <div class="flex flex-wrap justify-center">
                    <vs-button class="w-full" @click.prevent="clearFilters">Eliminar filtros</vs-button>
                  </div>
                </vx-card>
              </div>

              <!-- GRID VIEW -->
              <!--              <template>-->
              <div class="flex-1 mr-4">
                <!--                                  <component :is="scrollbarTag" ref="mainSidebarPs" class="p-0 max-h-screen" :settings="settings" :key="$vs.rtl">-->
                <!--                  <div>-->
                <!--                  <vue-perfect-scrollbar class="scroll-area" v-once :settings="settings" @ps-scroll-y="scrollHandle">-->
                <div class="items-grid-view vx-row match-height">
                  <div class="vx-col w-full sm:w-1/2 xl:w-1/3" v-for="item in products" :key="item.id">

                    <item-grid-view :item="item">

                      <!-- SLOT: ACTION BUTTONS -->
                      <template slot="action-buttons">
                        <div class="flex flex-wrap">

                          <!-- PRIMARY BUTTON: ADD TO WISH LIST -->
                          <div class="item-view-primary-action-btn p-3 flex flex-grow items-center justify-center cursor-pointer">

                            <span class="text-xl font-bold ml-2">Q{{ getPrice(item).toFixed(2) }}</span>
                          </div>

                          <!-- SECONDARY BUTTON: ADD-TO/VIEW-IN CART -->
                          <div v-if="isInCart(item.id)"
                               class="item-view-secondary-action-btn bg-success p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                               @click="cartButtonClicked(item)">
                            <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4"/>

                            <span class="text-sm font-semibold ml-2">VER EN CARRITO</span>
                          </div>
                          <div v-else
                               class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                               @click="cartButtonClicked(item)">
                            <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4"/>

                            <span v-if="selectedStore" class="text-sm font-semibold ml-2">AGREGAR</span>
                            <span v-else class="text-xs ml-2">Por favor selecciona una tienda</span>
                          </div>
                        </div>
                      </template>
                    </item-grid-view>

                  </div>
                  <div class="content-area__content">
                    <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500">
                      <vs-button radius icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" color="success"/>
                    </back-to-top>
                  </div>
                </div>
                <!--                  </vue-perfect-scrollbar>-->
                <!--                  </div>-->
                <!-- SCROLL TO TOP BUTTON -->
                <!--                                  </component>-->
              </div>
              <!--              </template>-->
            </div>
          </div>

          <item-detail-view class="mt-4" v-if="inItemScreen"/>

          <profile class="mt-4 mx-1" v-if="inProfileScreen"/>

          <check-out class="mt-4" v-if="inCheckoutScreen"/>

          <order-view class="mt-4" v-if="inOrderScreen" :data="orderData"/>

          <locations class="mt-4" v-if="inLocationsScreen && GoogleMaps"/>
          <locations-mapbox class="mt-4" v-if="inLocationsScreen && MapboxMaps"/>

          <shipping-terms class="mt-4" v-if="inShippingScreen"/>

          <page-footer/>

          <!--            <div>-->
          <!--            </div>-->
        </div>

        <!-- SIDEBAR FOR SMALL SCREENS -->
        <vs-sidebar class="lg:hidden" parent="#anf-main-container" default-index="1" color="primary" spacer v-model="sidebarActive" :hidden-background="true">
          <div class="ml-4">
            <div class="flex items-center justify-between">
              <h6 class="font-bold mb-3">Categorías</h6>
              <feather-icon icon="XCircleIcon" class="mr-2 cursor-pointer text-danger" size="3x" @click="sidebarActive = false"/>
            </div>
            <div @click="setCategory(null)" class="flex items-center cursor-pointer py-1">
              <feather-icon icon="CircleIcon" :svgClasses="[{ 'text-primary fill-current': !selectedCategory}, 'h-5 w-5']"/>
              <span class="ml-2" :class="{'text-primary': !selectedCategory}">Todos</span>
            </div>
            <div v-for="item in mainCategories" :key="item.id">
              <div @click="toCategory(item)" class="flex items-center cursor-pointer py-1">
                <feather-icon icon="CircleIcon" :svgClasses="[{ 'text-primary fill-current': selectedCategory && item.id == selectedCategory.id}, 'h-5 w-5']"/>
                <span class="ml-2" :class="{'text-primary': selectedCategory && item.id == selectedCategory.id}">{{ item.name }}</span>
              </div>
              <div v-for="subCategory in subCategories(item)" :key="subCategory.id" class="flex ml-6 text-md">
                <div @click="toCategory(subCategory)" class="flex items-center cursor-pointer py-1 text-sm">
                  <feather-icon icon="CircleIcon" :svgClasses="[{ 'text-primary fill-current': selectedCategory && subCategory.id == selectedCategory.id}, 'h-5 w-5']"/>
                  <span class="ml-2" :class="{'text-primary': selectedCategory && subCategory.id == selectedCategory.id}">{{ subCategory.name }}</span>
                </div>
              </div>
            </div>
          </div>

          <vs-divider/>

          <div class="flex justify-center mx-4">
            <vs-button class="w-full" @click.prevent="clearFilters">Eliminar filtros</vs-button>
          </div>
        </vs-sidebar>
      </div>
    </div>

  </div>
</template>

<script>
  import BackToTop from 'vue-backtotop';
  import VuePerfectScrollbar from 'vue-perfect-scrollbar';
  import {db} from '@/firebaseConfig';
/*
  import storesImport from '@/store/data/stores.json';
  import productsImport from '@/products.json';
*/

  export default {
    components: {
      BackToTop,
      VuePerfectScrollbar,
      PendingOrder: () => import('./components/PendingOrder'),
      Home: () => import('./Home'),
      ItemGridView: () => import('./components/ItemGridView'),
      ItemListView: () => import('./components/ItemListView'),
      ItemDetailView: () => import('./ECommerceItemDetailView'),
      CheckOut: () => import('./ECommerceCheckout'),
      OrderView: () => import('./Order'),
      CartDropDown: () => import('./components/CartDropDown'),
      User: () => import('./components/User'),
      Profile: () => import('./pages/Profile'),
      Locations: () => import('./Locations'),
      LocationsMapbox: () => import('./LocationsMapbox'),
      ShippingTerms: () => import('./ShippingTerms'),
      PageFooter: () => import('./Footer')
    },
    props: ['categoryId'],
    data() {
      return {
        // Filter Sidebar
        loaded: false,
        publicKey: '',
        urlEndpoint: '',
        pendingWindowActive: false,
        sidebarActive: false,
        breadcrumbs: [],
        isFilterSidebarActive: true,
        clickNotClose: true,
        refinementSearchValue: '',
        currentRefinement: '',
        currentItemView: 'item-grid-view',
        specialSelected: false,
        showSpecialOptions: false,
        specialOptions: null,
        hoverCategory: null,
        pricesRange: [],
        migrationList: [],
        orderData: {
          user: '',
          id: 0
        },
        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60
        }
      }
    },
    watch: {
      loaded(loaded) {
        if (loaded) {
          if (this.categories.length > 0) {
            if (this.categoryId > 0) {
              var category = this.categories.find(o => o.id === this.categoryId);
              if (category) {
                this.setCategory(category);
              }
            }
          }
        }
      },
      categoryId(categoryId) {
        alert(categoryId);
      },
      $route: {
        handler: function(newRoute) {
          this.validateRoute(newRoute);
        },
        deep: true
      }
      // '$route.path': function () {
      //   this.validateRoute(this.$route);
      // }
    },
    computed: {
/*
      productsSource() {
        return productsImport;
      },
      storesSource() {
        return storesImport;
      },
*/
      inMaintenance() {
        return this.$store.getters['getParameter']('general').maintenance;
      },

      validateStock() {
        return this.$store.getters['getParameter']('orders').checkStock;
      },

      pulseStockAPI() {
        return this.$store.getters['getParameter']('orders').pulseStockAPI;
      },

      giftOrdersActivated() {
        return this.$store.getters['getParameter']('orders').giftOrders;
      },

      toValue() {
        return (value, range) => [
          value.min !== null ? value.min : range.min,
          value.max !== null ? value.max : range.max
        ]
      },

      deliveryType() {
        return this.$store.state.deliveryType;
      },

      selectedStore() {
        return this.$store.state.selectedStore;
      },

      isInCart() {
        return (itemId) => this.$store.getters['eCommerce/isInCart'](itemId)
      },

      windowWidth() {
        return this.$store.state.windowWidth
      },

      activeUserInfo() {
        return this.$store.state.AppActiveUser;
      },

      priceRanges() {
        return this.$store.getters.priceRanges;
      },

      categories() {
        return this.$store.getters.categories;
      },

      productGroups() {
        return this.$store.state.productGroups.list;
      },

      inHomeScreen() {
        return (this.$store.state.homeScreen == 1);
      },

      inProductsScreen() {
        return (this.$store.state.homeScreen == 2);
      },

      inItemScreen() {
        return (this.$store.state.homeScreen == 3);
      },

      inCheckoutScreen() {
        return (this.$store.state.homeScreen == 4);
      },

      inOrderScreen() {
        return (this.$store.state.homeScreen == 12);
      },

      inProfileScreen() {
        return (this.$store.state.homeScreen == 6);
      },

      inLocationsScreen() {
        return (this.$store.state.homeScreen == 7);
      },

      inShippingScreen() {
        return (this.$store.state.homeScreen == 8);
      },

      selectedPriceRange() {
        return this.$store.state.priceRange;
      },

      selectedCategory() {
        return this.$store.state.selectedCategory;
      },

      products() {
        return this.$store.getters['refinedProductsList'];
        // return this.refine();
      },

      mainCategories() {
        return this.categories.filter(function (category) {
          return category.parentId == '';
        }).sort(function (a, b) {
          if (a.sequence > b.sequence) {
            return 1;
          } else {
            return -1;
          }
        });
      },
      scrollbarTag() {
        return this.$store.getters.scrollbarTag
      },
      stockAPI() {
        return this.$store.getters['getParameter']('stock').stockAPI;
      },
      GoogleMaps() {
        return (this.$store.getters['getParameter']('general').mapsAPI == 'Google');
      },
      MapboxMaps() {
        return (this.$store.getters['getParameter']('general').mapsAPI == 'Mapbox');
      }
    },
    methods: {
      /*
      migrate() {
        db.collection('catalogs').doc('showcase').update({list: this.$store.state.showcaseProducts});
      },
      productsImport() {
        var products = [];
        console.log('Migration: ', this.productsSource);
        for (var i = 0; i < this.productsSource.length; i++) {
          console.log(this.productsSource[i]);
          products.push({
            id: parseInt(this.productsSource[i].id),
            code: this.productsSource[i].id.trim(),
            name: this.productsSource[i].name.trim(),
            description: this.productsSource[i].hasOwnProperty('description') ? this.productsSource[i].description.trim() : '',
            slices: this.productsSource[i].hasOwnProperty('slices') ? this.productsSource[i].slices.trim() : '',
            price: parseFloat(this.productsSource[i].price),
            categories: this.productsSource[i].categories.trim(),
            variations: this.productsSource[i].hasOwnProperty('variations') ? this.productsSource[i].variations.trim() : '',
            upsell: this.productsSource[i].hasOwnProperty('upsell') ? this.productsSource[i].upsell.trim() : '',
            status: this.productsSource[i].status.trim(),
            available: true
          });
        }
        console.log(products);
        db.collection('catalogs').doc('products').set({list: products})
          .then((doc) => {
            console.log('Updated ', doc);
          })
          .catch((error) => {
            console.log(error)
          });
      },
      storesRead() {
        console.log(this.$store.getters.stores);
      },

      storesLoad() {
        db.collection('catalogs').doc('stores').update({list: this.storesSource.stores});
      },

      storesLoad() {
        console.log(this.storesSource);
        db.collection('catalogs').doc('stores').update({list: this.storesSource});
      },

      updateStoresSchedule() {
        let stores = JSON.parse(JSON.stringify(this.$store.state.stores.list));
        for (let i = 0; i < stores.length; i++) {
          stores[i].carryOutOpenHour = '08:00';
          stores[i].carryOutCloseHour = '20:00';
          stores[i].deliveryOpenHour = '08:00';
          stores[i].deliveryCloseHour = '20:00';
        }
        //db.collection('catalogs').doc('stores').update({list: stores});
        console.log(stores);
      },

      productsList() {
        console.log(this.$store.state.productslist);
      },

      oky() {
        const data = JSON.stringify({
          "exchangeCode": "28795X2TE3"
        });

        const config = {
          method: 'post',
          url: 'https://apidemo.oky.app/oky/open-service/v2/giftcards/exchangestatus',
          headers: { 
            'Content-Type': 'application/json', 
            'token': 'dca28f740f274a641b2930e336593bf8869826ae', 
            'Cookie': 'PHPSESSID=sv5ij3e7v7fcvhopk6jva5pipl; PHPSESSID=vfnrbe6u1768g3nrhsbi7h39rb'
          },
          data : data
        };

        this.$http(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });
      },


      oky1() {
        const self = this;
        this.$http.post('https://dominosoky.apigt.work/v1/operations/redeem', {
          okyURL: 'https://apidemo.oky.app/oky/open-service/v2/giftcards/exchangestatus',
          token: 'dca28f740f274a641b2930e336593bf8869826ae',
          code: '24317XHBYE'
        }).then(response => {
          if (response.data.success) {
            self.$vs.notify({
              title: 'Oky correcto',
              text: JSON.stringify(response.data.data),
              color: 'success'
            });
          } else {
            self.$vs.notify({
              title: 'Error al validar Oky',
              text: response.data.message,
              color: 'danger'
            });
          }
        }).catch(error => {
          var errorMessage = '';
          if (error.message) {
            errorMessage = error.message;
          } else if (error.response) {
            errorMessage = error.response.data.ErrorMessage;
          } else {
            errorMessage = 'Error de conectividad'
          }
          self.$vs.notify({
            title: 'Error al validar Oky',
            text: errorMessage,
            color: 'danger'
          });
        })
      },

      getOrdersById() {
        db.collection('orders')
          .where('id', '>', 125811)
          .get()
          .then(q => {
            const orders = q.docs.map(doc => doc.data());
            console.log(orders);
          })
      },

      getOrdersByDate() {
        this.$vs.loading({
          text: 'Cargando órdenes, espera por favor',
          type: 'point'
        });
        const self = this;
        const startDate = new Date('2024-05-01')
        const endDate = new Date('2024-05-31 23:59:59')
        db.collection('orders')
          .where('date', '>=', startDate)
          .where('date', '<', endDate)
          .get()
          .then(q => {
            let orders = [];
            q.forEach(doc => {
              orders.push({
                userName: doc.data().userName,
                email: doc.data().email,
                phone: doc.data().phone,
                address: doc.data().address.address,
                cityName: doc.data().address.cityName,
                stateName: doc.data().address.stateName
              });
            })
            // const orders = q.docs.map(doc => doc.data());
            // console.log(orders);
            const ordersText = JSON.stringify(orders);
            navigator.clipboard.writeText(ordersText).then(function() {
              alert('Async: Copying to clipboard was successful!');
            }, function(err) {
              alert('Async: Could not copy text: ' + err);
            });
            self.$vs.loading.close();
          })
      },

      updateStoreNewSchedule() {
        let stores = JSON.parse(JSON.stringify(this.$store.state.stores.list));
        const i = 89;
        stores[i].delivery = true;
        stores[i].carryOutHours = [
          {
            close: "21:00",
            open: "8:00",
          },
          {
            close: "21:00",
            open: "8:00",
          },
          {
            open: "8:00",
            close: "21:00",
          },
          {
            close: "21:00",
            open: "8:00",
          },
          {
            close: "22:00",
            open: "8:00",
          },
          {
            open: "8:00",
            close: "22:00",
          },
          {
            close: "22:00",
            open: "8:00",
          },
        ];
        stores[i].deliveryHours = [
          {
            close: "21:00",
            open: "8:00",
          },
          {
            close: "21:00",
            open: "8:00",
          },
          {
            open: "8:00",
            close: "21:00",
          },
          {
            close: "21:00",
            open: "8:00",
          },
          {
            close: "22:00",
            open: "8:00",
          },
          {
            open: "8:00",
            close: "22:00",
          },
          {
            close: "22:00",
            open: "8:00",
          },
        ];
        db.collection('catalogs').doc('stores').update({list: stores});
        console.log(stores[i]);
      },

      updateStoreSchedules() {
        let stores = JSON.parse(JSON.stringify(this.$store.state.stores.list));
        let i = 0;
        for (i = 0; i < stores.length; i++) {
          if ('carryOutHours' in stores[i]) {
            stores[i].carryOutHours[0].open = '9:00';
            stores[i].carryOutHours[0].close = '20:00';
            stores[i].carryOutHours[1].open = '9:00';
            stores[i].carryOutHours[1].close = '20:00';
            stores[i].carryOutHours[2].open = '9:00';
            stores[i].carryOutHours[2].close = '20:00';
            stores[i].carryOutHours[3].open = '9:00';
            stores[i].carryOutHours[3].close = '20:00';
            stores[i].carryOutHours[4].open = '9:00';
            stores[i].carryOutHours[4].close = '20:00';
            stores[i].carryOutHours[5].open = '9:00';
            stores[i].carryOutHours[5].close = '20:00';
            stores[i].carryOutHours[6].open = '9:00';
            stores[i].carryOutHours[6].close = '20:00';
          } else {
            stores[i].carryOutHours = [
              {
                close: "20:00",
                open: "9:00",
              },
              {
                close: "20:00",
                open: "9:00",
              },
              {
                close: "20:00",
                open: "9:00",
              },
              {
                close: "20:00",
                open: "9:00",
              },
              {
                close: "20:00",
                open: "9:00",
              },
              {
                close: "20:00",
                open: "9:00",
              },
              {
                close: "20:00",
                open: "9:00",
              },
            ];
          }
          if ('deliveryHours' in stores[i]) {
            stores[i].deliveryHours[0].open = '9:00';
            stores[i].deliveryHours[0].close = '20:00';
            stores[i].deliveryHours[1].open = '9:00';
            stores[i].deliveryHours[1].close = '20:00';
            stores[i].deliveryHours[2].open = '9:00';
            stores[i].deliveryHours[2].close = '20:00';
            stores[i].deliveryHours[3].open = '9:00';
            stores[i].deliveryHours[3].close = '20:00';
            stores[i].deliveryHours[4].open = '9:00';
            stores[i].deliveryHours[4].close = '20:00';
            stores[i].deliveryHours[5].open = '9:00';
            stores[i].deliveryHours[5].close = '20:00';
            stores[i].deliveryHours[6].open = '9:00';
            stores[i].deliveryHours[6].close = '20:00';
          } else {
            stores[i].deliveryHours = [
              {
                close: "20:00",
                open: "9:00",
              },
              {
                close: "20:00",
                open: "9:00",
              },
              {
                close: "20:00",
                open: "9:00",
              },
              {
                close: "20:00",
                open: "9:00",
              },
              {
                close: "20:00",
                open: "9:00",
              },
              {
                close: "20:00",
                open: "9:00",
              },
              {
                close: "20:00",
                open: "9:00",
              },
            ];
          }
        }
        db.collection('catalogs').doc('stores').update({list: stores});
        console.log(stores);
      },

      updateStoreSchedules() {
        let stores = JSON.parse(JSON.stringify(this.$store.state.stores.list));
        let i = 0;
        for (i = 0; i < stores.length; i++) {
          if ('carryOutHours' in stores[i]) {
            stores[i].carryOutHours[0].open = '11:00';
            stores[i].carryOutHours[0].close = '20:00';
            stores[i].carryOutHours[6].open = '8:00';
            stores[i].carryOutHours[6].close = '20:00';
          } else {
            stores[i].carryOutHours = [
              {
                close: "20:00",
                open: "11:00",
              },
              {
                close: stores[i].carryOutCloseHour,
                open: stores[i].carryOutOpenHour,
              },
              {
                close: stores[i].carryOutCloseHour,
                open: stores[i].carryOutOpenHour,
              },
              {
                close: stores[i].carryOutCloseHour,
                open: stores[i].carryOutOpenHour,
              },
              {
                close: stores[i].carryOutCloseHour,
                open: stores[i].carryOutOpenHour,
              },
              {
                close: stores[i].carryOutCloseHour,
                open: stores[i].carryOutOpenHour,
              },
              {
                close: "20:00",
                open: "8:00",
              },
            ];
          }
          if ('deliveryHours' in stores[i]) {
            stores[i].deliveryHours[0].open = '11:00';
            stores[i].deliveryHours[0].close = '20:00';
            stores[i].deliveryHours[6].open = '8:00';
            stores[i].deliveryHours[6].close = '20:00';
          } else {
            stores[i].deliveryHours = [
              {
                close: "20:00",
                open: "11:00",
              },
              {
                close: stores[i].deliveryCloseHour,
                open: stores[i].deliveryOpenHour,
              },
              {
                close: stores[i].deliveryCloseHour,
                open: stores[i].deliveryOpenHour,
              },
              {
                close: stores[i].deliveryCloseHour,
                open: stores[i].deliveryOpenHour,
              },
              {
                close: stores[i].deliveryCloseHour,
                open: stores[i].deliveryOpenHour,
              },
              {
                close: stores[i].deliveryCloseHour,
                open: stores[i].deliveryOpenHour,
              },
              {
                close: "20:00",
                open: "8:00",
              },
            ];
          }
        }
        db.collection('catalogs').doc('stores').update({list: stores});
        console.log(stores);
      },

      updatePriceProducts() {
        let products = JSON.parse(JSON.stringify(this.$store.state.products.list));
        let i = 0;
        for (i = 0; i < products.length; i++) {
          products[i].originalPrice = products[i].price;
          products[i].price2 = products[i].price;
          products[i].minimumPrice2 = 0;
          products[i].group = '';
        }
        //db.collection('catalogs').doc('products').update({list: products});
        console.log(products);
      },

      updateStoresCarryOut() {
        let stores = JSON.parse(JSON.stringify(this.$store.state.stores.list));
        for (let i = 0; i < stores.length; i++) {
          stores[i].carryOut = true;
        }
        db.collection('catalogs').doc('stores').update({list: stores});
        console.log(stores);
      },

      storesBackup() {
        const stores = JSON.stringify(this.$store.state.stores.list);
        navigator.clipboard.writeText(stores);
      },

      storesList() {
        let stores = JSON.parse(JSON.stringify(this.$store.state.stores.list));
        for (let i = 0; i < stores.length; i++) {
          delete stores[i].carryOutHours;
          delete stores[i].deliveryHours;
          delete stores[i].perimeter;
        }
        navigator.clipboard.writeText(JSON.stringify(stores)).then(function() {
          alert('Async: Copying to clipboard was successful!');
        }, function(err) {
          alert('Async: Could not copy text: ' + err);
        });
      },

      updateStoresApplication() {
        let stores = JSON.parse(JSON.stringify(this.$store.state.stores.list));
        for (let i = 0; i < stores.length; i++) {
          stores[i].application = 'PIXEL';
        }
        db.collection('catalogs').doc('stores').update({list: stores});
        console.log(stores);
      },

      updateProductsPulse() {
        let products = JSON.parse(JSON.stringify(this.$store.state.products.list));
        for (let i = 0; i < products.length; i++) {
          if (!products[i].hasOwnProperty('pulseId')) {
            products[i].pulseId = '';
          }
          if (!products[i].hasOwnProperty('pulseStockId')) {
            products[i].pulseStockId = '';
          }
        }
        db.collection('catalogs').doc('products').update({list: products});
        console.log(products);
      },

      updateStorePerimeter() {
        let stores = JSON.parse(JSON.stringify(this.$store.state.stores.list));
        const i = 8;
        stores[i].delivery = true;
        stores[i].perimeter = [
          "-90.4867594607181,14.6385889663143",
          "-90.4867594607181,14.6385889663143"
        ];
        // stores[i].latitude = 14.62673;
        // stores[i].longitude = -90.524639;
        stores[i].delivery = true;
        //db.collection('catalogs').doc('stores').update({list: stores});
        console.log(stores[i]);
      },

      updateStoresHours() {     
        let stores = JSON.parse(JSON.stringify(this.$store.state.stores.list));
        for (let i = 0; i < stores.length; i++) {
          if (stores[i].hasOwnProperty('carryOutHours') && stores[i].hasOwnProperty('deliveyHours')) {
            stores[i].carryOutHours[5].open = '8:00';
            stores[i].carryOutHours[6].open = '8:00';
            stores[i].carryOutHours[4].close = '21:00';
            stores[i].carryOutHours[5].close = '21:00';
            stores[i].carryOutHours[6].close = '21:00';
            stores[i].deliveyHours[5].open = '8:00';
            stores[i].deliveyHours[6].open = '8:00';
            stores[i].deliveyHours[4].close = '21:00';
            stores[i].deliveyHours[5].close = '21:00';
            stores[i].deliveyHours[6].close = '21:00';
          }
        }
        console.log(stores);
        // db.collection('catalogs').doc('stores').update({list: stores});
      },

      updateStoresStatus() {
        const closed = ['3085', '3067', '3100', '3060', '3124', '3070', '3077', '3092', '3056', '3095', '3068', '3059', '3051', '3057', '3038', '3002']
        let stores = JSON.parse(JSON.stringify(this.$store.state.stores.list));
        for (let i = 0; i < stores.length; i++) {
            stores[i].status = closed.includes(stores[i].code) ? 'IN' : 'ACT';
        }
        console.log(stores);
        // db.collection('catalogs').doc('stores').update({list: stores});
      },


      getOrdersByDate() {
        const startDate = new Date('2023-12-01')
        const endDate = new Date('2023-12-31 23:59:59')
        console.log(startDate, endDate),
        db.collection('orders')
          .where('date', '>=', startDate)
          .where('date', '<', endDate)
          .get()
          .then(q => {
            let orders = [];
            let order = {};
            let i = 0;
            q.forEach(doc => {
              order = {
                id: doc.data().id,
                c3Id: doc.data().c3Id,
                userName: doc.data().userName,
                email: doc.data().email,
                phone: doc.data().phone,
                address: doc.data().address.address,
                cityName: doc.data().address.cityName,
                stateName: doc.data().address.stateName,
                date: doc.data().date.toDate(),
                deliveryType: doc.data().deliveryType,
                orderTotal: doc.data().orderTotal,
                storeCode: doc.data().store.code,
                storeName: doc.data().store.name,
                quantity1: 0,
                product1: '',
                price1: 0,
                quantity2: 0,
                product2: '',
                price2: 0,
                quantity3: 0,
                product3: '',
                price3: 0,
                quantity4: 0,
                product4: '',
                price4: 0,
                quantity5: 0,
                product5: '',
                price5: 0
              };
              for (i = 0; i < doc.data().products.length; i++){
                if (i == 0) {
                  order.quantity1 = doc.data().products[i].quantity;
                  order.product1 = doc.data().products[i].description;
                  order.price1 = doc.data().products[i].price;
                } else if (i == 1) {
                  order.quantity2 = doc.data().products[i].quantity;
                  order.product2 = doc.data().products[i].description;
                  order.price2 = doc.data().products[i].price;
                } else if (i == 2) {
                  order.quantity3 = doc.data().products[i].quantity;
                  order.product3 = doc.data().products[i].description;
                  order.price3 = doc.data().products[i].price;
                } else if (i == 3) {
                  order.quantity4 = doc.data().products[i].quantity;
                  order.product4 = doc.data().products[i].description;
                  order.price4 = doc.data().products[i].price;
                } else if (i == 5) {
                  order.quantity5 = doc.data().products[i].quantity;
                  order.product5= doc.data().products[i].description;
                  order.price5 = doc.data().products[i].price;
                }
              }
              orders.push(order);
            })
            // const orders = q.docs.map(doc => doc.data());
            const ordersText = JSON.stringify(orders);
            navigator.clipboard.writeText(ordersText).then(function() {
              alert('Async: Copying to clipboard was successful!');
            }, function(err) {
              alert('Async: Could not copy text: ' + err);
            });
          })
      },

      updatePrice2Products() {
        let products = JSON.parse(JSON.stringify(this.$store.state.products.list));
        let i = 0;
        for (i = 0; i < products.length; i++) {
          products[i].price3 = products[i].price;
        }
        // db.collection('catalogs').doc('products').update({list: products});
        console.log(products);
      },

      updateStoresPriceList() {
        let stores = JSON.parse(JSON.stringify(this.$store.state.stores.list));
        for (let i = 0; i < stores.length; i++) {
          stores[i].priceList = 1;
        }
        // db.collection('catalogs').doc('stores').update({list: stores});
        console.log(stores);
      },

      updateStoreSchedulesFull() {
        let stores = JSON.parse(JSON.stringify(this.$store.state.stores.list));
        let i = 0;
        for (i = 0; i < stores.length; i++) {
          stores[i].carryOutOpenHour = '8:00';
          stores[i].carryOutCloseHour = '20:00';
          stores[i].carryOutHours[0].open = '8:00';
          stores[i].carryOutHours[0].close = '20:00';
          stores[i].carryOutHours[1].open = '8:00';
          stores[i].carryOutHours[1].close = '20:00';
          stores[i].carryOutHours[2].open = '8:00';
          stores[i].carryOutHours[2].close = '20:00';
          stores[i].carryOutHours[3].open = '8:00';
          stores[i].carryOutHours[3].close = '20:00';
          stores[i].carryOutHours[4].open = '8:00';
          stores[i].carryOutHours[4].close = '20:00';
          stores[i].carryOutHours[5].open = '8:00';
          stores[i].carryOutHours[5].close = '20:00';
          stores[i].carryOutHours[6].open = '8:00';
          stores[i].carryOutHours[6].close = '20:00';

          stores[i].deliveryOpenHour = '8:00';
          stores[i].deliveryCloseHour = '20:00';
          stores[i].deliveryHours[0].open = '8:00';
          stores[i].deliveryHours[0].close = '20:00';
          stores[i].deliveryHours[1].open = '8:00';
          stores[i].deliveryHours[1].close = '20:00';
          stores[i].deliveryHours[2].open = '8:00';
          stores[i].deliveryHours[2].close = '20:00';
          stores[i].deliveryHours[3].open = '8:00';
          stores[i].deliveryHours[3].close = '20:00';
          stores[i].deliveryHours[4].open = '8:00';
          stores[i].deliveryHours[4].close = '20:00';
          stores[i].deliveryHours[5].open = '8:00';
          stores[i].deliveryHours[5].close = '20:00';
          stores[i].deliveryHours[6].open = '8:00';
          stores[i].deliveryHours[6].close = '20:00';
        }
        db.collection('catalogs').doc('stores').update({list: stores});
        console.log(stores);
      },

      duplicateStore() {
        let stores = JSON.parse(JSON.stringify(this.$store.state.stores.list));
        let last = JSON.parse(JSON.stringify(stores[stores.length - 1]));
        stores.push(last);
        last = stores[stores.length - 1];
        last.status = 'IN';
        last.id = stores.length;
        db.collection('catalogs').doc('stores').update({list: stores});
        console.log(stores);
      },

      */

      activateSidebar() {
        this.sidebarActive = true;
        window.scrollTo(0, 0);
      },

      validateRoute(route) {
        if (route.name != 'locations') {
          if (this.deliveryType == '' || this.selectedStore == null) {
            this.$store.dispatch('updateDeliveryType', '');
            this.$store.dispatch('updateSelectedStore', null);
          }
        }
        if (route.name == 'checkout') {
          this.$store.dispatch('updateHomeScreen', 4);
        } else if (route.name == 'category-view') {
          if (route.hasOwnProperty('params')) {
            if (route.params.hasOwnProperty('category')) {
              if (this.categories && this.categories.length > 0) {
                const category = this.categories.find(c => c.name.CIAI().replace(/\s/g, '-').toLowerCase() == route.params.category);
                if (category) {
                  this.setCategory(category);
                }
              } else {
                const self = this;
                setTimeout(function () {
                  self.validateRoute(route);
                }, 500);
              }
            }
          }
        } else if (route.name == 'order') {
          if (route.hasOwnProperty('params')) {
            if (route.params.hasOwnProperty('orderId')) {
              const self = this;
              db.collection('orders')
                .doc(route.params.orderId)
                .get()
                .then(snapshot => {
                  self.orderData = snapshot.data();
                  self.$store.dispatch('updateHomeScreen', 12);
                })
                .catch(() => {
                  self.$router.push('/').catch(() => {});
                });
            } else {
              this.$router.push('/').catch(() => {});
            }
          } else {
            this.$router.push('/').catch(() => {});
          }
        } else if (route.name == 'profile') {
          this.$store.dispatch('updateHomeScreen', 6);
        } else if (route.name == 'locations') {
          this.$store.dispatch('updateHomeScreen', 7);
        } else if (route.name == 'terms') {
          this.$store.dispatch('updateHomeScreen', 8);
        } else if (route.name == 'item-detail-view') {
          if (route.params.hasOwnProperty('item')) {
            this.$store.dispatch('updateHomeScreen', 3);
          }
        } else if (route.hasOwnProperty('params')) {
          if (route.params.hasOwnProperty('item')) {
            this.$store.dispatch('updateHomeScreen', 3);
          }
        }
        if (this.$store.state.showCartWarning) {
          this.$store.dispatch('updateCartWarning', false);
          this.pendingWindowActive = true;
        }
      },
      // GRID VIEW - ACTIONS
      toggleFilterSidebar() {
        if (this.clickNotClose) return
        this.isFilterSidebarActive = !this.isFilterSidebarActive
      },
      categoryColor(category) {
        var color = 'transparent';
        if (this.selectedCategory) {
          color = category.id == this.selectedCategory.id || category.subCategories.split(',').includes(this.selectedCategory.id) ? 'black' : 'transparent';
        }
        // var color = 'transparent';
        // if (this.selectedCategory) {
        //   color = category.id == this.selectedCategory.id || category.subCategories.split(',').includes(this.selectedCategory.id) ? '#b8c2cc' : 'transparent';
        // }
        return color;
      },
      setGiftOrder() {
        this.$store.dispatch('updateDeliveryType',  'delivery');
        this.$store.dispatch('updateGiftOrder',  true);
        this.$router.push({ name: 'locations' });
      },
      getPrice(item) {
        let price = item.price;
        if (this.selectedStore != null) {
          if ('priceList' in this.selectedStore) {
            if (this.selectedStore.priceList == 3) {
              price = item.price3;
            }
          }
        }
        return price;
      },
      async getStock(item) {
        let available = false;
        if (item.hasOwnProperty('stockId')) {
          const response = await this.$http.post(`${this.stockAPI}/stock/product`, {
            storeID: this.selectedStore.stockId,
            productID: parseInt(item.stockId)
          });
          if (response) {
            if (response.data) {
              available = (response.data.data[0].stock > self.quantity);
            } else {
              available = false;
            }
          } else {
            available = false;
          }
        } else {
          available = false;
        }
        return available;
      },
      async additemInCart(item) {
        let available = !this.validateStock;
        if (item.hasOwnProperty('stockId') && this.validateStock) {
          this.$vs.loading({
            text: `Validando existencia de ${item.name}, espera por favor`,
            type: 'point'
          });
          if (this.selectedStore.application == 'PIXEL') {
            const response = await this.$http.post(`${this.stockAPI}/stock/product`, {
              storeID: this.selectedStore.stockId,
              productID: parseInt(item.stockId)
            });
            if (response) {
              if (response.data) {
                if (response.data != null) {
                  available = (response.data.data[0].stock > 1);
                }
              }
            }
          } else if (this.selectedStore.application == 'PULSE') {
            const response = await this.$http.post(`${this.stockAPI}/stock/pulse`, {
              storeId: this.selectedStore.stockId,
              productId: item.pulseStockId
            });
            if (response) {
              if (response.data) {
                if (response.data != null) {
                  available = (response.data.data.stock > 1);
                }
              }
            }
          }
          this.$vs.loading.close();
        }
        if (available) {
          // eslint-disable-next-line
          const product = structuredClone(item);
          product.price = this.getPrice(item);
          this.$store.dispatch('eCommerce/additemInCart', {...item, cartQuantity: 1, productGroups: this.productGroups});
          window.fbq('track', 'AddToCart');
        } else {
          this.$vs.notify({
            title: '¡Lo sentimos!',
            text: `No tenemos disponibilidad de ${item.name} en ${this.selectedStore.name}`,
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          });
        }
      },
      cartButtonClicked(item) {
        if (this.selectedStore) {
          if (item.combo) {
            this.specialOptions = JSON.parse(JSON.stringify(item));
            this.showSpecialOptions = true;
          } else {
          // eslint-disable-next-line
            const product = structuredClone(item);
            product.price = this.getPrice(item);
            this.isInCart(item.id) ? this.$router.push('/checkout').catch(() => {}) : this.additemInCart(product);
          }
        } else {
          this.$router.push({ name: 'locations' });
        }
      },
      subCategories(category) {
        return this.categories.filter(function (subCategory) {
          return category.subCategories.split(',').includes(subCategory.id);
        }).sort(function (a, b) {
          if (a.sequence > b.sequence) {
            return 1;
          } else {
            return -1;
          }
        });
      },
      addCouponCart() {
        this.additemInCart(this.specialOptions);
      },

      toCategory(item) {
        this.$router.push({name: 'category-view', params: {category: item.name.CIAI().toLowerCase().replace(/ /g, '-')}}).catch(() => {
        });
      },

      setCategory(category) {
        this.$store.dispatch('updateProductSearch', '');
        this.currentRefinement = '';
        if (category == null) {
          this.$store.dispatch('updateSelectedCategory', category);
          this.breadcrumbs = [];
        } else {
          if (category.parentId == '') {
            if (this.hoverCategory) {
              this.hoverCategory = null;
            }
            this.$store.dispatch('updateSelectedCategory', category);
            this.breadcrumbs = [];
          } else {
            var parent = this.categories.find(item => item.id === category.parentId);
            this.$store.dispatch('updateSelectedCategory', category);
            this.hoverCategory = null;
            this.breadcrumbs = [{title: parent.name, category: parent}];
          }
          this.breadcrumbs.push({title: category.name, category: category});
        }
        if (!['home', 'category-view'].includes(this.$router.currentRoute.name) || category == null) {
          this.$router.push('/');
        }
        this.sidebarActive = false;
      },
      showSubcategories(category) {
        var show = false;
        if (this.hoverCategory) {
          if (this.hoverCategory.id == category.id) {
            show = true;
          }
        }
        return show;
      },
      refinePriceRange(item) {
        this.$store.dispatch('updateProductSearch', '');
        this.currentRefinement = '';
        this.$store.dispatch('updatePriceRange', item);
      },
      refine(phrase) {
        this.$store.dispatch('updateSelectedCategory', null);
        this.$store.dispatch('updatePriceRange', null);
        this.$store.dispatch('updateProductSearch', phrase);
        this.currentRefinement = phrase;
      },
      clearFilters() {
        this.refinePriceRange(null);
        this.setCategory(null);
        this.refine('');
      },
      goHome() {
        this.clearFilters();
        this.$store.dispatch('updateHomeScreen', 1);
        this.$router.push('/');
      },
      scrollHandle(evt) {
        console.log(evt)
      },
      logout() {
        alert('logout');
      }
    },
    // created() {
    //   this.publicKey =  this.$store.getters['getParameter']('imagekit').publicKey;
    //   this.urlEndpoint =  this.$store.getters['getParameter']('imagekit').url + '/images/';
    // },
    mounted() {
      const self = this;
      setTimeout(function () {
        self.validateRoute(self.$route);
        self.loaded = true;
      }, 500);
    }
  }

</script>


<style lang="scss">
  #anf-sub-c {
    background-color: #EEEEEE;
    border: none;
    color: black;
    padding: 16px 32px;
    text-align: center;
    font-size: 16px;
    margin: 4px 2px;
    transition: 0.3s;
  }

  #anf-sub-c:hover {
    background-color: #dae1e7;
  }

  #anf-instant-search-demo {
    .anf-header {
      .anf-filters-label {
        width: calc(260px + 2.4rem);
      }
    }

    #anf-content-container {


      .vs-sidebar {
        position: relative;
        float: left;
      }
    }

    .anf-search-input-right-aligned-icon {
      padding: 1rem 1.5rem;
    }

    .anf-price-slider {
      min-width: unset;
    }

    .item-view-primary-action-btn {
      color: #2c2c2c !important;
      background-color: #f6f6f6;
      min-width: 50%;
    }

    .item-view-secondary-action-btn {
      min-width: 50%;
    }
  }

  .theme-dark {
    #anf-instant-search-demo {
      #anf-content-container {
        .vs-sidebar {
          background-color: #10163a;
        }
      }
    }
  }

  @media (min-width: 992px) {
    .vs-sidebar-rounded {
      .vs-sidebar {
        border-radius: .5rem;
      }

      .vs-sidebar--items {
        border-radius: .5rem;
      }
    }
  }

  @media (max-width: 992px) {
    #anf-content-container {
      .vs-sidebar {
        position: absolute !important;
        float: none !important;
      }
    }
  }

  .scroll-area {
    position: relative;
    margin: auto;
    width: 400px;
    height: 300px;
  }

</style>
